import { useContext } from "react";
import TextInput from "./TextInput";

type FormProperties = {
  context: React.Context<any>;
  property: string;
  label?: string;
  required?: boolean;
  assetsData?: string;
  index?: number;
  treatAsTypeahead?: boolean;
  translation?: Record<string, string>;
  type?: string;
  ["data-cy"]?: string;
};

const FormTextInput = ({
  context,
  property,
  label,
  assetsData,
  index,
  required,
  treatAsTypeahead,
  translation,
  type,
  ...props
}: FormProperties) => {
  const { state, dispatch, errors, setErrors } = useContext(context);
  const disabledArray = state?.disabled;
  const isDisabled = disabledArray?.find(
    (keyword: string) => keyword === property
  );

  const value =
    assetsData && index !== undefined
      ? state?.[assetsData]?.[index]?.[property]
      : state?.[property];

  const typeaheadValue = treatAsTypeahead ? value?.name : undefined;
  return (
    <TextInput
      value={
        treatAsTypeahead
          ? typeaheadValue
          : translation
          ? translation?.[value] || value
          : value
      }
      setValue={(data) => {
        const dispatchedData = treatAsTypeahead
          ? { name: data, value: data }
          : data;

        dispatch({
          type: property,
          payload:
            index !== undefined
              ? { index, data: dispatchedData }
              : dispatchedData,
        });
      }}
      type={type}
      error={{
        allErrors: errors,
        name: property,
        message: errors?.[property],
        setErrors: setErrors,
      }}
      label={label}
      required={required}
      disabled={!!isDisabled}
      data-cy={props["data-cy"]}
    />
  );
};

export default FormTextInput;
